import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';

@AutoUnsubscribe()
@Component({
    selector: 'ReportToEmail',
    templateUrl: './confirm-archive-report.component.html',
    styleUrls: ['./confirm-archive-report.component.css']
})

export class ConfirmArchiveReportComponent implements OnDestroy, OnInit {



    // private snapshotToDelete: AutoRunSnapshot;

    private _reportName: string;
    // private _autoRunDate: Date;

    get reportName(): string {
        return this._reportName;
    }

    set reportName(value: string) {
        this._reportName = value;
    }

    archiveTypes = '';

    // get autoRunDate(): Date {
    //     return this._autoRunDate;
    // }

    // set autoRunDate(value: Date) {
    //     this._autoRunDate = value;
    // }


    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<ConfirmArchiveReportComponent>
    ) {

    }

    ngOnInit() {
        this.reportName = this.reportService.SelectedReport.Name;
        // if (this.reportService.SelectedReport.StudentDigitalContent != null) {
        //     this.archiveTypes = this.archiveTypes + 'Student Digital Content\n';
        // }

        // if (this.reportService.SelectedReport.StudentPortfolio != null) {
        //     this.archiveTypes = this.archiveTypes + 'Student Portfolio\n';
        // }

        // if (this.reportService.SelectedReport.ArchiveToTCM) {
        //     this.archiveTypes = this.archiveTypes + 'Tyler Content Manager\n';
        // }

    }

    ngOnDestroy() {
    }

    okClick() {

        // const snapshotId = this.snapshotToDelete.AutoRunReportSnapshots_ID;

        // this.reportService.deleteReportSnapshot(snapshotId).subscribe(res => {

        //     // todo: check that the delete was successful
        //     this.reportService.autoRunSnapshot = null;
        //     // this.ReportToEmailEvent.emit(true);

        //     // if (this.reportService.inDebugMode) {

        //     // }
        // });

        this.dialogRef.close(true);
    }

    cancelClick() {
        // this.ReportToEmailEvent.emit(false);
        this.dialogRef.close(false);
    }


}